import { digObject } from '@domain-group/javascript-utils'

import handleCallbackAction from '@functions/handleCallbackAction'

import useCurrentUser from '@hooks/useCurrentUser'
import useUser from '@hooks/useUser'

import { getRealhubLoginParams } from '@functions/entity'

function useLoginAsUser(options = {}) {
  const redirectUrl = digObject(options, 'redirect', '')
  const userId = digObject(options, 'userId')

  const currentUserPayload = useCurrentUser()
  const { currentUser } = currentUserPayload
  const selectedId = userId || currentUser?.id

  const userPayload = useUser({ id: selectedId })
  const {
    callbacks: {
      loginAsUser,
    },
  } = userPayload

  return {
    callbacks: {
      loginAsUser: (params?: object) => handleCallbackAction({
        callbacks: {
          // @ts-expect-error TS2322
          action: loginAsUser,
          buildActionParams: () => [{ ...getRealhubLoginParams(), redirect: redirectUrl, ...params }],
        },
        shouldRedirect: true,
        toastText: 'Logged In',
      }),
    },
  }
}

export type UseLoginAsUserPayload = ReturnType<typeof useLoginAsUser>

export default useLoginAsUser
